import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, firstValueFrom, map, merge, Observable, Subject } from 'rxjs';
import { InsertConocimientoRequest } from '../requests/insert-conocimiento-request';
import { InsertHabilidadRequest } from '../requests/insert-habilidad-request';
import { UpdateConocimientoRequest } from '../requests/update-conocimiento-request';
import { UpdateHabilidadRequest } from '../requests/update-habilidad-request';
import { GetListaConocimientosResponse } from '../responses/get-lista-conocimientos-response';
import { GetListaHabilidadesResponse } from '../responses/get-lista-habilidades-response';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-adm-catalogos-gestion',
  templateUrl: './adm-catalogos-gestion.component.html',
  styleUrls: ['./adm-catalogos-gestion.component.css']
})
export class AdmCatalogosGestionComponent implements OnInit {
  conocimientosLoaded = false;
  habilidadesLoaded = false;


  hasSearchedConocimientos=false;
  hasSearchedHabilidades=false;

  public breadcrumb: any;
  title;
  message;
  catalogoConocimientos : boolean = true; //true: conocimientos, false: habilidades
  responseConocimientos : GetListaConocimientosResponse[];
  responseHabilidades : GetListaHabilidadesResponse[];
  actionModal : string;

  isFirst = false;
  isFirstHabilidad = false;

  conocimientoForm;
  habilidadForm;

  responseConocimientoCopy : GetListaConocimientosResponse;
  showSearchedConocimiento = false;
  responseHabilidadCopy : GetListaHabilidadesResponse;
  showSearchedHabilidad = false;

  actionConocimientos = false;
  actionHabilidades = false;
  template: TemplateRef<any>;
  conocimientoActualizar;
  habilidadActualizar;

  constructor(private formBuilder: FormBuilder,
              private toast : ToastrService,
              private _route: ActivatedRoute,
              private modalService: NgbModal,
              private adminService : AdminService) {
  }

  async ngOnInit() {
    this.initForms();
    this.breadcrumb = {
      'mainlabel': 'Gestión de catálogos',
    };
    await this.getListConocimientos();
  }

  initForms()
  {
    this.habilidadForm = this.formBuilder.group({
      description: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(80)])
    });
    this.conocimientoForm = this.formBuilder.group({
      description: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(150)])
    });
  }

  

  async getListConocimientos() : Promise<boolean>
  {
    try 
    {
      this.responseConocimientos = [];
      const result = await firstValueFrom(this.adminService.getListaConocimientos());
      if(result.length > 0)
      {
        this.responseConocimientos = result;
        this.showSearchedConocimiento = false;

        this.conocimientosLoaded=true;
        return true;
      }
      this.toast.info('Aún no hay habilidades técnicas registradas.','Aviso');
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async getListHabilidades() : Promise<boolean>
  {
    try 
    {
      const result = await firstValueFrom(this.adminService.getListaHabilidades());
      if(result.length > 0)
      {
        this.responseHabilidades = result;
        this.showSearchedHabilidad = false;

        this.habilidadesLoaded=true;
        return true;
      }else
      this.toast.info('Aún no hay habilidades socioemocionales registradas.','Aviso');
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async selectCatalogoConocimientos() {
    if(!this.conocimientosLoaded || this.hasSearchedConocimientos)
    {
      this.hasSearchedConocimientos=false;
      this.responseConocimientoCopy = null;
      this.isFirst=false;
      await this.getListConocimientos();
    }
    this.model = '';
    this.catalogoConocimientos = true;
  }

  async selectCatalogoHabilidades() {
    if(!this.habilidadesLoaded || this.hasSearchedHabilidades)
    {
      this.hasSearchedHabilidades=false;
      this.isFirstHabilidad=false;
      this.responseHabilidadCopy = null;
      await this.getListHabilidades();
    }
    this.model = '';
    this.catalogoConocimientos = false;
  }

  

  model: any;
  focus$ = new Subject<string>();

  searchOnFocusConocimiento = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$).pipe(
      map(term => (term === '' ? []
        : this.responseConocimientos.filter(v => v.descripcion.toLowerCase().indexOf(term.toLowerCase()) > -1)
                  .map(v => v.descripcion)
        ).slice(0, 10))
    );
  }

  searchOnFocusHabilidad = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$).pipe(
      map(term => (term === '' ? []
        : this.responseHabilidades.filter(v => v.descripcion.toLowerCase().indexOf(term.toLowerCase()) > -1)
                  .map(v => v.descripcion)
        ).slice(0, 10))
    );
  }

  inputFormatter = (result: string) => {
    return result;
  }
  
  onFocused(e: any): void {
    this.focus$.next(e.target.value);
  }

  conocimientoFound: GetListaConocimientosResponse;

  searchConocimiento()
  {
    if(this.model)
    {
      this.conocimientoFound = this.responseConocimientos.find(data => data.descripcion === this.model);
      if(this.conocimientoFound)
      {
        this.toast.success('Registro encontrado, ya puedes visualizarlo.','Búsqueda completada');
        this.responseConocimientoCopy = this.conocimientoFound;
        this.isFirst = false;
        this.showSearchedConocimiento = true;
        this.hasSearchedConocimientos = true;
        this.model = '';
      }
      else
        this.toast.info('No se encontraron coincidencias con la búsqueda.','');
    }
    else
    this.toast.info('Complete los campos para una búsqueda.','');
  }

  habilidadFound: GetListaHabilidadesResponse;

  searchHabilidad()
  {
    if(this.model)
    {
      this.habilidadFound = this.responseHabilidades.find(data => data.descripcion === this.model);
      if(this.habilidadFound)
      {
        this.toast.success('Registro encontrado, ya puedes visualizarlo.','Búsqueda completada');
        this.responseHabilidadCopy = this.habilidadFound;
        this.showSearchedHabilidad = true;
        this.hasSearchedHabilidades = true;
        this.isFirstHabilidad = false;
        this.model = '';
      }
      else
        this.toast.info('No se encontraron coincidencias con la búsqueda.','');
    }
    else
    this.toast.info('Complete los campos para una búsqueda.','');
  }

  // Acciones para manejar modal conocimientos

  addConocimiento(template: TemplateRef<any>) {
    this.message='Registra las nuevas habilidades técnicas que un egresado podrá agregar a su perfil y los que un ofertador podrá requerir al momento de indicar los requisitos del puesto.'
    this.title='Nueva Habilidad Técnica';
    this.actionConocimientos=false;
    this.template = template;
    this.modalService.open(this.template,{windowClass: 'animated fadeInUp',keyboard:false,backdrop: false});
  }

  deployActionButton()
  {
    if(this.actionConocimientos === false) //insertar
      this.trySubmitConocimiento();
    else //actualizar
      this.tryUpdateConocimiento();
  }

  trySubmitConocimiento()
  {
    if(this.conocimientoForm.invalid)
    {
      this.toast.error('Verifique la información.','Error');
      return;
    }
    try {
      let request = {} as InsertConocimientoRequest;
      request.descripcion = this.f.description.value;
      this.adminService.agregarConocimiento(request).subscribe({
        next: (result) => 
        {
          if(result.idConocimiento > 0)
          {
            let newConocimiento : GetListaConocimientosResponse = { idConocimiento: result.idConocimiento, descripcion: result.descripcion};
            this.responseConocimientos.unshift(newConocimiento);
            this.isFirst = true;
            this.closeModal();
          }
        },
        error: (error) => {
          this.toast.error('Ocurrió un error con el servidor.','Error');
        },
        complete: () => 
        {
          this.conocimientoForm.reset();
        }
    });
    } catch (error) {
      this.toast.error('Ocurrió un error con el servidor.','Error');
    }
  }

  updateConocimiento(template: TemplateRef<any>,conocimiento) {
    this.message='Revisa los cambios antes de confirmar la actualización de los datos.'
    this.title='Actualizar Habilidad Técnica';
    this.actionConocimientos=true;
    this.template = template;
    this.conocimientoActualizar = conocimiento;
    this.setDataFromLocalToForm();
    this.modalService.open(this.template,{windowClass: 'animated fadeInUp',keyboard:false,backdrop: false});
  }

  setDataFromLocalToForm()
  {
    this.f.description.setValue(this.conocimientoActualizar.descripcion);  
  }

  tryUpdateConocimiento()
  {
    if(this.conocimientoForm.invalid)
    {
      this.toast.error('Verifique la información.','Error');
      return;
    }
    try {
      let request = {} as UpdateConocimientoRequest;
      request.nuevaDescripcion = this.f.description.value;
      request.idConocimiento = this.conocimientoActualizar.idConocimiento;
      this.adminService.actualizarConocimiento(request).subscribe({
        next: (result) => 
        {
          if(result.success)
          {
            // cancelar busqueda
            this.responseConocimientoCopy = null;
            this.hasSearchedConocimientos = false;
            this.showSearchedConocimiento = false;
            // -------
            let index = this.responseConocimientos.findIndex(data => data.idConocimiento === this.conocimientoActualizar.idConocimiento);
            this.responseConocimientos.splice(index,1);
            let newConocimiento : GetListaConocimientosResponse = { idConocimiento: request.idConocimiento, descripcion: request.nuevaDescripcion};
            this.responseConocimientos.unshift(newConocimiento);
            this.isFirst = true;
            this.conocimientoActualizar = null;
            this.closeModal();
          }
          else
            this.toast.error(result.mensaje,'');
        },
        error: (error) => {
          this.toast.error('Ocurrió un error con el servidor.','Error');
        }
    });
    } catch (error) {
      this.toast.error('Ocurrió un error con el servidor.','Error');
    }
  }

  // Acciones para manejar modal conocimientos


  // Acciones para manejar modal habilidades

  deployHabActionButton()
  {
    if(this.actionHabilidades === false) //insertar
      this.trySubmitHabilidad();
    else //actualizar
      this.tryUpdateHabilidad();
  }

  addHabilidad(template: TemplateRef<any>) {
    this.message='Registra las nuevas habilidades socioemocionales que un egresado podrá indicar que tiene y las que un ofertador podrá indicar como ideales para quién ocupe el puesto ofertado.'
    this.title='Nueva Habilidad Socioemocional';
    this.actionHabilidades=false;
    this.template = template;
    this.modalService.open(this.template,{windowClass: 'animated fadeInUp',keyboard:false,backdrop: false});
  }

  updateHabilidad(template: TemplateRef<any>,habilidad) {
    this.message='Revisa los cambios antes de confirmar la actualización de los datos.';
    this.title='Actualizar Habilidad Socioemocional';
    this.actionHabilidades=true;
    this.template = template;
    this.habilidadActualizar = habilidad;
    this.setDataFromLocalToFormHab();
    this.modalService.open(this.template,{windowClass: 'animated fadeInUp',keyboard:false,backdrop: false});
  }

  trySubmitHabilidad()
  {
    if(this.habilidadForm.invalid)
    {
      this.toast.error('Verifique la información.','Error');
      return;
    }
    try {
      let request = {} as InsertHabilidadRequest;
      request.descripcion = this.j.description.value;
      this.adminService.agregarHabilidad(request).subscribe({
        next: (result) => 
        {
          if(result.idHabilidad > 0)
          {
            let newHabilidad : GetListaHabilidadesResponse = {
              idHabilidad: result.idHabilidad, descripcion: result.descripcion,
              contadorSeleccion: 0,
              banderaEliminar: false
            };
            this.responseHabilidades.unshift(newHabilidad);
            // unshift agrega al inicio del arreglo
            this.isFirstHabilidad=true;
            this.closeModal();
          }
          else
            this.toast.error(result.mensaje,'');
        },
        error: (error) => {
          this.toast.error('Ocurrió un error con el servidor.','Error');
        },
        complete: () => 
        {
          this.habilidadForm.reset();
        }
    });
    } catch (error) {
      this.toast.error('Ocurrió un error con el servidor.','Error');
    }
  }

  tryUpdateHabilidad()
  {
    if(this.habilidadForm.invalid)
    {
      this.toast.error('Verifique la información.','Error');
      return;
    }
    try {
      let request = {} as UpdateHabilidadRequest;
      request.nuevaDescripcion = this.j.description.value;
      request.idHabilidad = this.habilidadActualizar.idHabilidad;
      this.adminService.actualizarHabilidad(request).subscribe({
        next: (result) => 
        {
          if(result.success)
          {
            // cancelar busqueda
            this.responseHabilidadCopy = null;
            this.hasSearchedHabilidades = false;
            this.showSearchedHabilidad = false;
            // -------
            let index = this.responseHabilidades.findIndex(data => data.idHabilidad === this.habilidadActualizar.idHabilidad);
            this.responseHabilidades.splice(index,1);
            let newHabilidad = { idHabilidad: request.idHabilidad, descripcion: request.nuevaDescripcion,banderaEliminar:false,contadorSeleccion:0} as GetListaHabilidadesResponse;
            this.responseHabilidades.unshift(newHabilidad);
            this.habilidadActualizar=null;
            this.isFirstHabilidad=true;
            this.closeModal();
          }  
          else
            this.toast.error(result.mensaje,'');
        },
        error: (error) => {
          this.toast.error('Ocurrió un error con el servidor.','Error');
        }
    });
    } catch (error) {
      this.toast.error('Ocurrió un error con el servidor.','Error');
    }
  }

  setDataFromLocalToFormHab()
  {
    this.j.description.setValue(this.habilidadActualizar.descripcion);  
  }


  // Acciones para manejar modal habilidades

  closeModal() {
    this.habilidadForm.reset();
    this.conocimientoForm.reset();
    this.modalService.dismissAll(this.template);
  }


  get f() {
    return this.conocimientoForm.controls;
  }

  get j() {
    return this.habilidadForm.controls;
  }
}